import { Component, OnInit } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import {Location} from '@angular/common';
@Component({
  selector: 'app-validate',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.css']
})
export class ValidateComponent implements OnInit {

  constructor( public mobileNav: MobileNavService,private _location: Location) { }

  ngOnInit() {
  }

  onClickMe() {
      console.log('button clicked');
      console.log(this.mobileNav);
        this.mobileNav.showSideNav();
    }
  backBtnClick(){
    this._location.back();
  }

}